import Utils from './../utils/Utils'
import packageConfig from './../../package.json'

const youboraDefaultOptions = {
  "tracking": {
    "enabled": false
  },
  "analytics": {
    "enabled": false
  }
};

export const youboraOptionsPlugin = (youboraOptions, username) => {
    const valuesPlugin = {
      "accountCode" : youboraOptions.accountcode,
      "host" : youboraOptions.host,
      "isInfinity" : false,
      "username" : username,
      "background.settings" : "stop",
      "app.name" : "AAF",
      "app.releaseVersion" : packageConfig.version
    };

    return new window.youbora.Plugin(valuesPlugin)
}

export const getMetadataYoubora = () => {
  const youboraOptions = Utils.getApaMetadataKey('youbora_options', youboraDefaultOptions);
  const {tracking, analytics} = youboraOptions;

  return {tracking, analytics};
}

export const youboraLauncher = ()=> {
  try {
    const youboraOptions = getMetadataYoubora();
    const {tracking, analytics} = youboraOptions;
    const usernamePlugins = window.youboraUserId || 'null'

    if(window.youbora && window.youboraRegion){
      //const youboraByRegion = youboraOptions[window.youboraRegion];
      // Youbora
      if(window.youboraTrackingPlugin){
        const { options = {} } = window.youboraTrackingPlugin || {};

        options['app.name'] = 'AAF';
        options['app.releaseVersion'] = packageConfig.version;

        if (options && options.username) {
          options.username = window.youboraUserId;
        }
        if (options && options['user.name']) {
          options['user.name'] = window.youboraUserId;
        }

      } else if(tracking && tracking.enabled){
        window.youboraTrackingPlugin = youboraOptionsPlugin(tracking, usernamePlugins);
      }
      // Infinity
      if(analytics && analytics.enabled){
        if(!window.youboraAnalyticsPlugin){
          window.youboraAnalyticsPlugin = youboraOptionsPlugin(analytics, usernamePlugins);
        }

        if(window.youboraAnalyticsPlugin
          && window.youboraAnalyticsPlugin.infinity
          && window.youboraAnalyticsPlugin.infinity.begin
          && typeof window.youboraAnalyticsPlugin.infinity.begin === "function")
          window.youboraAnalyticsPlugin.infinity.begin();
      }
    }
  } catch(e) {
    console.log("[Youbora] Error in start instance of plugin", youboraOptions);
  }
};

export const updateOptionsUserYoubora = (userId, username) => {
  const options = {
    "user.name": userId,
    "user.email": username
  }

  if(window.youboraTrackingPlugin && window.youboraTrackingPlugin.setOptions) {
    window.youboraTrackingPlugin.setOptions(options);
  }
};

export const setParamsYouboraLogin = (userId, username) => {
  const {tracking, analytics} = getMetadataYoubora();
  
  if(window.youbora) {
    if(tracking && tracking.enabled) {
      window.youboraTrackingPlugin = youboraOptionsPlugin(tracking, userId || "null")
      updateOptionsUserYoubora(userId, username)
    }
    if(analytics && analytics.enabled) {
      window.youboraAnalyticsPlugin = youboraOptionsPlugin(analytics, userId || "null")
    }
  }
};



// WEBPACK FOOTER //
// ./src/config/youboraLoader.js